import { ApolloClient, InMemoryCache, from, HttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { authenticatedFetch } from '@shopify/app-bridge/utilities';
import { SMAUG_GRAPHQL_URI } from 'utils/constants';

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
});

const createClient = (app) => {
  const httpLink = new HttpLink({
    uri: SMAUG_GRAPHQL_URI,
    fetch: authenticatedFetch(app),
    credentials: 'same-origin'
  });

  return new ApolloClient({
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache()
  });
};

export default createClient;
